import { DateTime } from 'luxon';
import firebase from 'firebase';
import { AvailabilitySlot } from './availability.types';

export const serializeAvailability = (
  availability: Date,
  interval: number,
  timezoneOffset: number,
  snapshot: firebase.firestore.QuerySnapshot,
  maxRestaurantTakeAway: number,
  maxRestaurantDelivery: number
): AvailabilitySlot => {
  const timeStart = firebase.firestore.Timestamp.fromDate(availability);
  const slots = snapshot.docs.find((item) => item.data()?.time_start?.toMillis() === timeStart.toMillis());
  const currentTakeAwayCount = slots?.data()?.take_away_count ?? 0;
  const currentDeliveryCount = slots?.data()?.delivery_count ?? 0;

  const av =  {
    timeStart: slots?.data()?.time_start?.toMillis() ?? timeStart.toMillis(),
    timeEnd: slots?.data()?.time_end?.toMillis() ?? firebase.firestore.Timestamp.fromDate(DateTime.fromJSDate(availability).plus({ minutes: interval }).toJSDate()).toMillis(),
    offset: timezoneOffset,
    remainingTakeAwaySlots: maxRestaurantTakeAway - currentTakeAwayCount,
    remainingDeliverySlots: maxRestaurantDelivery - currentDeliveryCount,
    takeAwayPercentage: (currentTakeAwayCount * 100) / maxRestaurantTakeAway,
    deliveryPercentage: (currentDeliveryCount * 100) / maxRestaurantDelivery
  };
  return av;
};
